import Seo from "components/general/Seo";
import React from "react";
import { CartScreen } from "screens/Cart";
export default function Page() {
	// const navigation = useNavigation();

	// React.useEffect(() => {
	// 	navigation.setOptions({
	// 		header: undefined,
	// 		headerTitle: "Cart",
	// 	 });
	//   }, [navigation]);

	return (
		<>
			<Seo title="My Cart | Abconet" description="Review and manage items added to your cart before placing orders through Abconet." />
			<CartScreen />
		</>
	);
}
